import styled from "styled-components";
// import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .label {
    margin-right: 3px;
    float: left;
    font-weight: 700;
  }
`;

export default Wrapper;
